/**
 * @Author:
 * @Description:
 * @DateTime: Created in 15:34 2020/1/23
 */
import store from 'storejs'

export default class LocalStore {
	static globalPath = 'GLOBAL'

	/**
	 * 获取某一个页面路径下的缓存数据
	 * @param {string} key
	 * @returns {object}
	 */
	static getPathData (key?: string): object {
		return LocalStore.getData(window.location.pathname, key)
	}

	/**
	 * 设置某一个页面下的缓存数据
	 * @param {object} data
	 */
	static setPathData (data: object, key?: string) {
		LocalStore.setData(window.location.pathname, data, key)
	}

	/**
	 * 获取某一个页面路径下的缓存数据
	 * @param {string} key
	 * @returns {object}
	 */
	static getGlobalData (key?: string): object {
		return LocalStore.getData(LocalStore.globalPath, key)
	}

	/**
	 * 设置某一个页面下的缓存数据
	 * @param {object} data
	 */
	static setGlobalData (data: object) {
		LocalStore.setData(LocalStore.globalPath, data)
	}

	/**
	 * 设置数据
	 * @param {string} pathname
	 * @param {object} data
	 */
	static setData (pathname: string, data: object, key?: string) {
		let localData = store.get(pathname) || {}
		if (key) {
			localData[key] = data
		} else {
			localData = {...localData, ...data}
		}
		store.set(pathname, localData)
    }
    
    static clearData (pathname: string,  key?: string) {
		let localData = store.get(pathname) || {}
		if (key) {
			localData[key] = null
		} else {
			localData = null
		}
		store.set(pathname, localData)
	}

	/**
	 * 获取数据
	 * @param pathname
	 * @param key
	 */
	static getData (pathname: string, key?: string) {
		let localData = store.get(pathname) || {}
		return key ? localData[key] : localData
	}
}
